// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","formItemCol":"formItemCol--3i0rJ","labelInfo":"labelInfo--3kGLz","actionButton":"actionButton--3DVmM"};